module.exports = new __parcel__URL__("handshake.427e9da6.png").toString();